import React from 'react';
import _ from 'lodash';

import { CustomerBookingCard } from './CustomerBookingCard';
import { IRosterBooking } from '../../types';

interface CustomerItemsProps {
  bookings?: IRosterBooking[][];
  refreshData?: () => void;
}

/** Local component for filtering out bookings for the selected day. */
export const CustomerItems = ({ bookings, refreshData }: CustomerItemsProps) => {
  return (
    <>
      {bookings?.map((bookingGroup, rowIdx) =>
        bookingGroup.map((booking, bookingIdx) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <CustomerBookingCard booking={booking} key={bookingIdx} refreshData={refreshData} rowIndex={rowIdx} />
        )),
      )}
    </>
  );
};
